/* JM26 designer-filtre (designers-list-26 + designer-grid-26) — progressiv enhancement.
   Delegation ligger på document, så intet går tabt ved en Theme Editor-swap
   (shopify:section:load) og ingen re-init er nødvendig. Samme mønster som collection-26.js.

   KONTRAKT A — oversigt (designers-list-26):
     rod    : [data-d26-list]
     fane   : a.d26-tab med data-d26-filter="<handle>" | "all"
     blok   : [data-d26-designer="<handle>"]
     status : [data-d26-status] (sr-only, role=status)
     aktiv  : .is-active + aria-current="true"
     skjul  : hidden-attribut  (CSS: .d26-list [data-d26-designer][hidden]{display:none!important})
   Uden JS: fanerne er ÆGTE ankre til #d26-d-<handle> og springer i stedet for at
   filtrere. Intet er skjult server-side (SEO + no-JS).

   KONTRAKT B — enkelt designer (designer-grid-26):
     rod    : #d26-shop-<section.id>  med data-total + data-count-template
     chip   : button.d26-chip[data-d26-filter], aria-pressed
     sort   : select[data-d26-sort]
     kort   : [data-d26-item] med data-type/data-price/data-created/data-pos
     tal    : [data-d26-count] (h2, visuelt) + [data-d26-status] (sr-only, role=status)
   Uden JS: <noscript><style> skjuler chips + sort; brugeren får hele det
   server-sorterede grid. Chips/sort rendres KUN når paginate.pages <= 1.

   Den GAMLE designers-filter.liquid-JS (selektorer #product-grid .grid__item,
   .product-item-wrapper, .product-vendor, .product-title) er bevidst IKKE
   erstattet — den matchede ikke live-markup og filtrerede intet.
   Bundgridet (main-collection-product) filtreres ikke herfra. */
(function () {
  'use strict';
  if (window.__d26Init) return;
  window.__d26Init = true;

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- A. oversigt: designer-faner ---------- */
  function applyList(root, key) {
    var shown = 0;
    root.querySelectorAll('[data-d26-designer]').forEach(function (el) {
      var on = key === 'all' || el.getAttribute('data-d26-designer') === key;
      el.hidden = !on;
      if (on) shown++;
    });
    root.querySelectorAll('.d26-tab').forEach(function (t) {
      var on = t.getAttribute('data-d26-filter') === key;
      t.classList.toggle('is-active', on);
      if (on) { t.setAttribute('aria-current', 'true'); }
      else { t.removeAttribute('aria-current'); }
    });
    var status = root.querySelector('[data-d26-status]');
    if (status) status.textContent = shown === 1 ? '1 designer vist' : shown + ' designere vist';
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var tab = e.target && e.target.closest ? e.target.closest('.d26-tab') : null;
    if (!tab) return;
    var root = tab.closest('[data-d26-list]');
    if (!root) return;

    e.preventDefault();
    var key = tab.getAttribute('data-d26-filter') || 'all';
    applyList(root, key);

    try {
      history.replaceState(null, '',
        key === 'all' ? location.pathname + location.search : '#d26-d-' + key);
    } catch (err) { /* ignorér */ }

    if (root.getBoundingClientRect().top < 0) {
      root.scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth', block: 'start' });
    }
  });

  /* Dyb-link: /collections/designers#d26-d-sabre-design
     (ingen CSS.escape — den escaper IDENTIFIKATORER, ikke citerede
     attributværdier; vi scanner i stedet fanerne direkte.) */
  function initHash() {
    var m = /^#d26-d-(.+)$/.exec(location.hash || '');
    if (!m) return;
    var block = document.getElementById('d26-d-' + m[1]);
    if (!block) return;
    var root = block.closest('[data-d26-list]');
    if (!root) return;
    var tabs = root.querySelectorAll('.d26-tab');
    var found = Array.prototype.some.call(tabs, function (t) {
      return t.getAttribute('data-d26-filter') === m[1];
    });
    if (!found) return;
    applyList(root, m[1]);
    root.scrollIntoView({ block: 'start' });
  }

  /* ---------- B. enkelt designer: chips + sortering ---------- */
  function shop(root) {
    if (root.dataset.d26Init === '1') return;
    root.dataset.d26Init = '1';

    var grid    = root.querySelector('[data-d26-grid]');
    var items   = Array.prototype.slice.call(root.querySelectorAll('[data-d26-item]'));
    var chips   = Array.prototype.slice.call(root.querySelectorAll('[data-d26-filter]'));
    var sortEl  = root.querySelector('[data-d26-sort]');
    var countEl = root.querySelector('[data-d26-count]');
    var statusEl= root.querySelector('[data-d26-status]');
    if (!grid || !items.length) return;

    var tpl    = root.getAttribute('data-count-template') || '';
    var total  = parseInt(root.getAttribute('data-total'), 10) || items.length;
    var active = 'all';

    function paint() {
      var shown = 0;
      for (var i = 0; i < items.length; i++) {
        var on = active === 'all' || items[i].getAttribute('data-type') === active;
        items[i].hidden = !on;              /* hidden-attributtet er sandheden */
        if (on) shown++;
      }
      var txt = tpl ? tpl.replace('{shown}', shown).replace('{total}', total) : '';
      if (countEl && txt) countEl.textContent = txt;   /* h2, visuelt — ingen aria-live */
      if (statusEl && txt) statusEl.textContent = txt; /* sr-only, role=status */
    }

    function order(mode) {
      var frag = document.createDocumentFragment();
      items.slice().sort(function (a, b) {
        switch (mode) {
          case 'price-asc':  return (+a.dataset.price)   - (+b.dataset.price);
          case 'price-desc': return (+b.dataset.price)   - (+a.dataset.price);
          case 'newest':     return (+b.dataset.created) - (+a.dataset.created);
          default:           return (+a.dataset.pos)     - (+b.dataset.pos); /* serverens orden */
        }
      }).forEach(function (el) { frag.appendChild(el); });
      grid.appendChild(frag);              /* ét reflow uanset antal kort */
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          c.classList.remove('is-active');
          c.setAttribute('aria-pressed', 'false');
        });
        chip.classList.add('is-active');
        chip.setAttribute('aria-pressed', 'true');
        active = chip.getAttribute('data-d26-filter');
        paint();
      });
    });
    if (sortEl) sortEl.addEventListener('change', function () { order(this.value); });
  }

  function initShops() {
    document.querySelectorAll('.d26-shop[data-count-template]').forEach(shop);
  }

  function boot() { initHash(); initShops(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', initShops);
})();
